var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"module"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"btn-home",on:{"click":_vm.goToHome}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }